module.exports = __webpack_public_path__ + "static/media/sp49.b0b369d4.JPG";